import React from 'react';
import styled from 'styled-components';
import WorkoutItem from './WorkoutItem';
import { WorkoutTypes, WorkoutsProps } from '../../../types/workout.types';

function WorkoutList(props: WorkoutsProps) {
  return (
    <Container>
      {props.workouts.map((workout: WorkoutTypes) => (
        <WorkoutItem workout={workout} />
      ))}
    </Container>
  )
}

export default WorkoutList;

const Container = styled.div`
  width: 100%;
  overflow-y: scroll;
`